import { Dispatch, createContext, useContext } from 'react'
import type IPageArtworkDetail from 'types/IPageArtworkDetail'

/**
 * @param state
 * @param action
 */
export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_INITIAL_STATE':
      return {
        ...state,
        ...action.payload,
        isRecommendationsTriggered: false
      }
    case 'TRIGGER_RECOMMENDATIONS':
      return {
        ...state,
        isRecommendationsTriggered: action.payload
      }
    case 'SET_ARTWORKINFORMATION':
      return {
        ...state,
        artworkInformation: action.payload
      }
    case 'SET_ATTACHMENTSINFO':
      return {
        ...state,
        attachmentsInformation: action.payload
      }
    case 'SET_ROOMSINFO':
      return {
        ...state,
        roomsInformation: action.payload
      }
    case 'SET_LABELS':
      return {
        ...state,
        labels: action.payload
      }
    case 'SET_VIDEOS':
      return {
        ...state,
        videos: action.payload
      }
    default:
      return { ...state }
  }
}

export const initialState = {
  /**
   * These are the CMS that come from the server side injected into the entry point that is set in _cmsModuleMap
   */
  CMSProps: {},
  /**
   * App labels, come from redux, they are filtered before inserted here, so it does not contain all the app labels
   * just the needed ones, and they are accessible with labels.OnlineShowRoom.labelName
   */
  labels: null,
  /**
   * Online show data begins as null, and its fetched in the client, as there are things needed, like show name
   */
  onlineShowData: null,
  /**
   * Gallery data
   */
  galleryData: null,
  /**
  * Gallery data
  */
  accountData: null,
  /**
   * Pray for NextJs 9 so we can use a hook...
   */
  router: null,
  /**
   * Attachments pdfs
   */
  attachments: null,
  attachmentsInformation: null,
  artworkInformation: null,
  roomsInformation: null,
  videos: null,
  isRecommendationsTriggered: false
}

type StateType = {
  CMSProps: {
    [x: string]: string,
    pageMetaInfo: any
  },
  labels?: {
    [x: string]: {
      [x: string]: string
    }
  } | null,
  onlineShowData?: any,
  galleryData?: any,
  accountData?: any,
  router?: any,
  attachments?: any,
  attachmentsInformation?: any, // too complex
  artworkInformation: ABTypes.Monolith.ArtworkDetail & {
    showPrice?: boolean,
    isSold?: boolean,
    labelNotAvailable?: string,
    priceRange?: string,
    price?: string,
    labels?: {
      [x: string]: {
        [x: string]: string
      }
    } | null,
    labelExcludedTaxes?: string,
    galleryImage?: string,
    isGallery?: string,
    showEnded?: string,
    gallerySlug?: string,
    roomTitle?: string,
    gallery?: string,
    numberOfImages?: number,
    seeOnWallVisible?: string,
    artworkCleanTitle?: string,
    videos?: {
      isVideoSet?: boolean,
      id?: number,
      videoUrl?: string,
      videoType?: string
    },
    artworkInfo?: IPageArtworkDetail,
    name?: string,
    firstImageUrl?: string,
    showWhenExhibition?: boolean,
    showWhenShowroom?: boolean,
    showWhenCatalog?: boolean,
    artworkContactFormLabel?: {
      [x: string]: string
    },
    onlineShowId?: number,
    onlineShowName?: string,
    onlineMobileShowName?: string,
    accountName?: string,
    roomMainSectors?: Array<ABTypes.Crmsector.CrmSector>,
    hallAndBoothInfo?: string,
    textColorClass?: string,
    curatorPickLabel?: string,
    isPortrait?: boolean,
    artist?: string,
    artists?: Array<ABTypes.Monolith.ArtistSummary>,
    hybridShow?: string,
    material?: string,
    artworkSizeLabel?: string,
    labelCm?: string,
    labelInch?: string,
    weight?: string,
    artworkSizeWithFrameLabel?: string,
    showMeasures?: boolean,
    showRecommendationAlgorithms?: string,
    showRecommendations?: boolean,
    imageSrc?: string,
  },
  roomsInformation?: any,
  videos?: any,
  isRecommendationsTriggered: boolean
}

interface IOSRoomContext {
  state: StateType
  dispatch: Dispatch<any>
}

// @ts-ignore --> To be resolved
export const StateContext = createContext<IOSRoomContext>({ state: initialState, dispatch: () => null })

export const useModuleContext = () => useContext(StateContext)
